/**
 * Member API
 *
 * @author minkyoung.park@emcast.com
*/
import httpService from '@/api/httpService'
const memberApi = {
    // 패스워드 변경(Change Password)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-password
    changePassword(params) {
        return httpService.put('/membership/member/password', params)
    },

    // 패스워드 다음에 변경(set change after password)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-password-next
    changePasswordNext(params) {
        return httpService.put('/membership/member/password/next', params)
    },

    // 프로필 변경(Change Profile)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-change-profile
    uploadProileImage(params) {
        return httpService.put('/membership/member/profile', params)
    },

    // 프로필 조회(get member profile)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-profile
    getProileImage(params) {
        return httpService.get('/membership/member/profile', params)
    },

    // 사용자 상세 정보 조회(get member information)
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-info
    getMemberInfo(params) {
        return httpService.get('/membership/member', params)
    },

    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-account-fetch-info
    emailVarification(params) {
        return httpService.post('/member/membership/auth/email/request', params)
    },

    emailCodeVerfy(params) {
        return httpService.post('/member/membership/auth/email', params)
    },

    leaderBoard() {
        return httpService.get('/membership/point/ranking')
    },

    addPhoneNo(params) {
        // console.log('params',params)
        return httpService.put('/membership/member', params)
    },

    // https://clpapi.tinkeredu.co.kr/static/docs/point.html#resources-level-detail_http_request
    memberPoint() {
        return httpService.get('/membership/member/point')
    },

    termsAgree(params) {
        return httpService.put('/membership/member/termsAgree', params)
    },

    termsAgreeCheck() {
      return httpService.get('/corporation/brand/terms/notAgree')
    },

    authResponsibility(params) {
        return httpService.post('/member/membership/auth/responsibility', params)
    },

    deleteAccount(params) {
        return httpService.put('/membership/member/withdrawal/request', params);
    },

    // 신고 사유 리스트
    getReportReasonList() {
        return httpService.get('/codes/code/REPORT_REASON/combo');
    },
}

export default memberApi
